import React from 'react'

const Card = (props) => {
  return (
    <div className='w-11/12 lg:w-5/12 2xl:w-3/12 bg-white m-auto shadow-md rounded-lg flex items-center justify-center flex-col'>
      {props.children}
    </div>
  )
}

export default Card